import * as Sentry from '@sentry/react'

import { SENTRY_DSN } from 'Constants'

export function initErrorMonitoring() {
  Sentry.init({
    dsn: SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
    // DEBUG: true will log all events to the console
    // debug: true,
    environment: import.meta.env.MODE,
  })
}

export const captureException = Sentry.captureException
